<template>
  <div class="flex items-center gap-3">
    <div v-for="filter in filterDefinitions" :key="filter.key">
      <select
        :value="modelValue[filter.key] || ''"
        @change="updateFilter(filter.key, $event.target.value)"
        class="block rounded-lg border-0 py-2 pl-3 pr-8 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-500"
      >
        <option value="">{{ filter.label }}</option>
        <option v-for="option in filter.options" :key="option.value" :value="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  filterDefinitions: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const updateFilter = (key, value) => {
  emit("update:modelValue", { ...props.modelValue, [key]: value || null });
};
</script>
